import * as React from "react";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {FieldFactory} from "../common/ui/search/FieldFactory";
import {DateField, SearchForm, SearchFormField, TypeaheadTextField} from "../common/ui/search/SearchForm";
import {EntityType} from "../model";
import {actions} from "./actions";
import {ProductFilter as FilterObject} from "./model";
import {selectors} from "./selectors";
import {Button} from "react-bootstrap";
import {LcdIcon} from "../common/ui/icon/LcdIcon";

interface ProductsFilterStateProperties {
    filter: FilterObject;
}

interface ProductsFilterDispatchProperties {
    filterChanged: (newFilter) => Promise<void>;
}

interface NotificationProps {
    notifyFilterChanged?: () => any;
}

type ProductFilterProps = ProductsFilterStateProperties & ProductsFilterDispatchProperties & NotificationProps;

export const ANY_TEXT_SEARCH_FIELD_NAME = "anyText";

class ProductsFilterComponent extends React.Component<InjectedIntlProps & ProductFilterProps, {}> {

    _fields: SearchFormField[];

    _typeaheadTextField: TypeaheadTextField;
    _dateStartField: DateField;
    _dateEndField: DateField;

    constructor(props) {
        super(props);
        this._typeaheadTextField = FieldFactory.createTypeaheadTextField(this.props.intl);
        this._dateStartField = FieldFactory.createStartDateField(this.props.intl);
        this._dateEndField = FieldFactory.createEndDateField(this.props.intl);
        this._fields = [
            this._typeaheadTextField,
            this._dateStartField,
            this._dateEndField,
        ];
    }

    handleSearch = (formValues) => {
        this.props.notifyFilterChanged && this.props.notifyFilterChanged();

        return this.props.filterChanged({
            anyText: formValues[this._typeaheadTextField.name],
            startDate: formValues[this._dateStartField.name],
            endDate: formValues[this._dateEndField.name],
        });
    }

    render() {
        const {filter} = this.props;
        return (
            <div className="searchFormContainer searchFormWithClearFilter">
                <SearchForm fields={this._fields}
                            values={{
                                [this._typeaheadTextField.name]: filter.anyText || "",
                                [this._dateStartField.name]: filter.startDate || "",
                                [this._dateEndField.name]: filter.endDate || "",
                            }}
                            onSearch={this.handleSearch}
                            syncFieldsWithUrl={true}
                            entityType={EntityType.TYPE_PRODUCT}/>
                {Object.values(this.props.filter).filter(v => v).length > 0 &&
                    <div className="clearFilterButton">
                        <Button onClick={this.clearFilter}>
                            <LcdIcon icon={"eraser"}/>
                            <FormattedMessage id="studio.services.clear-filter" defaultMessage="Clear filter"/>
                        </Button>
                    </div>}
            </div>
        );
    }

    private clearFilter = () => {
        this.props.filterChanged({});
    };

}

const mapStateToProps = (state) => ({
    filter: selectors.getFilter(state),
});

const mapDispatchToProps = (dispatch) => {
    return {
        filterChanged: (newFilter) => {
            dispatch(actions.setFilter(newFilter));
            dispatch(actions.clearData());
            return Promise.resolve();
        },
    };
};

export const ProductsFilter = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProductsFilterComponent));